/**
 *
 * @/functions/miscellaneous.js
 *
 */

//
// IMPORTS
//

//

//
//
//

export const escapeXML = str => String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
